export default "__VITE_ASSET__DyhX8FUN__"